var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import CalendarIcon from '@heroicons/react/outline/CalendarIcon.js';
import clsx from 'clsx';
import { Input } from '../Input/index.js';
import { useUniqueId } from '../utils/unique-id.js';
import { useDatePicker } from './useDatePicker.js';
import { cleanDate } from './utils.js';
export const DateTimePicker = (_a) => {
    var { className, dateFormat = 'Y-m-d H:i', invalid, onChange, value } = _a, rest = __rest(_a, ["className", "dateFormat", "invalid", "onChange", "value"]);
    const prefix = useUniqueId('DateTimePicker');
    const handleOnChange = dates => {
        if (!Array.isArray(dates) || dates.length !== 1) {
            onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(cleanDate(dates[0]));
    };
    const { startInputField } = useDatePicker(Object.assign({ value, onChange: handleOnChange, mode: 'single', prefix,
        dateFormat, allowInput: false, enableTime: true, showMonths: 1 }, rest));
    return (React.createElement("div", { className: clsx(className, 'w-[308px]') },
        React.createElement(Input, { ref: startInputField, invalid: invalid, leadingIcon: React.createElement(CalendarIcon, { className: "h-5 w-5", "aria-hidden": "true" }) })));
};
//# sourceMappingURL=DateTimePicker.js.map